export enum StorePublicStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  CLOSED = 'CLOSED',
  UPDATING = 'UPDATING',
  INITIATED = 'INITIATED',
  MISSING_BANK_ACCOUNT = 'MISSING_BANK_ACCOUNT',
}
